<template>
  <div class="model-content">
    <el-carousel v-if="imgs.length" indicator-position="none" :height="bannerHeight" :interval="3000">
        <el-carousel-item v-for="(item, i) in imgs" :key="item + i">
          <el-image
            :src="item"
            fit="fill"
          ></el-image>
        </el-carousel-item>
      </el-carousel>
    <div class="content-body">
      <h2>{{ title }}</h2>
      <div class="description" v-html="desc"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Swiper',
  props: {
    title: {
      type: String,
      default: ''
    },
    imgs: {
      type: Array,
      default:() => []
    },
    desc: {
      type: String,
      default: ''
    },
    imgHeight: {
      type: Number,
      default: 478
    },
    imgWidth: {
      type: Number,
      default: 950
    }
  },
  data() {
    return {
      screenWidth :0,
      bannerHeight: '0px'
    }
  },
  mounted() {
    // 首次加载时,需要调用一次
    this.screenWidth =  window.innerWidth - 68;
    this.setSize();
    // 窗口大小发生改变时,调用一次
    window.onresize = () =>{
    this.screenWidth =  window.innerWidth - 68;
    this.setSize();
    }
  },
  methods: {
    setSize () {
      // 通过浏览器宽度(图片宽度)计算高度 x1 / y1 = x2 / y2
      this.bannerHeight = this.imgHeight / this.imgWidth * this.screenWidth + 'px';
    }
  }
}
</script>

<style lang="less">
</style>



// WEBPACK FOOTER //
// src/components/content/Swiper/index.vue